/**
 * * Class NumericStepper that handles base functionality for .....
 * @class
 */
class NumericStepper {

    /**
     * Make a new NumericStepper.
     * @constructs
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {

        this._element = element;
        this._options = options;

        this._maxValue = typeof this._element.getAttribute('max') !== 'object' ? parseInt(this._element.getAttribute('max'), 10) : Number.MAX_SAFE_INTEGER;
        this._minValue = typeof this._element.getAttribute('min') !== 'object' ? parseInt(this._element.getAttribute('min'), 10) : Number.MIN_SAFE_INTEGER;
        this._stepValue = typeof this._element.getAttribute('step') !== 'object' ? parseInt(this._element.getAttribute('step'), 10) : 1;

        this.customFormChangeEvent = new CustomEvent('change');
        this._onClickIncrementBind = this._onClickIncrement.bind(this);
        this._onClickDecrementBind = this._onClickDecrement.bind(this);
        this._onChangeInputBind = this._onChangeInput.bind(this);
        this._onFocusInputBind = this._onFocusInput.bind(this);
        this._onBlurInputBind = this._onBlurInput.bind(this);

        this._initialize();

    }

    /**
     * if(/\D/.test(z))
     * Initialize document.
     * @private
     */
    _initialize() {
        this.incrementBtn = this._createButton('+');
        this.incrementBtn.className = 'btn btn-secondary btn-increment';
        this.incrementBtn.addEventListener('click', this._onClickIncrementBind);
        this.decrementBtn = this._createButton('-');
        this.decrementBtn.className = 'btn btn-secondary btn-decrement';
        this.decrementBtn.addEventListener('click', this._onClickDecrementBind);
        this._element.parentNode.insertBefore(this.decrementBtn, this._element);
        this._element.parentNode.insertBefore(this.incrementBtn, this._element.nextSibling);
        this._element.addEventListener('input', this._onChangeInputBind);
        this._element.addEventListener('focus', this._onFocusInputBind);
        this._element.addEventListener('blur', this._onBlurInputBind);
    }

    /**
     * @param {event} event - event on input
     * @private
     */
    _onChangeInput(event) {
        event.currentTarget.value = this.isNumber(event.currentTarget.value) ? event.currentTarget.value : '';
    }

    /**
     * @param {event} event - event on input
     * @private
     */
    _onFocusInput(event) {
        event.currentTarget.setAttribute('rememberValue', event.currentTarget.value);
        event.currentTarget.value = '';
    }

    /**
     * @param {event} event - event on input
     * @private
     */
    _onBlurInput(event) {
        if (event.currentTarget.value === '') {
            event.currentTarget.value = event.currentTarget.getAttribute('rememberValue');
        }
    }

    /**
     * @param {event} event -  click event on + button
     * @private
     */
    _onClickIncrement(event) {
        event.preventDefault();

        let value = parseInt(this._element.value, 10) || 0;
        value = Math.round(value + this._stepValue);
        if (value > this._maxValue) {
            value = this._maxValue;
        }
        this._element.value = value;
        this._element.form.dispatchEvent(this.customFormChangeEvent);
    }

    /**
     *
     * @param {event} event - click event on + button
     * @private
     */
    _onClickDecrement(event) {
        event.preventDefault();
        let value = parseInt(this._element.value, 10) || 0;
        value = Math.round(value - this._stepValue);
        if (value < this._minValue) {
            value = this._minValue;
        }
        this._element.value = value;
        this._element.form.dispatchEvent(this.customFormChangeEvent);
    }

    /**
     *
     * @param {Event} event - blur event
     * @private
     */
    _onBlur(event) {
        this.isNumber(event.currentTarget.value);
    }

    /**
     * @param {String} value - text for on he button
     * @returns {HTMLElement} btn - button
     * @private
     */
    _createButton(value) {
        const btn = document.createElement('button');
        btn.innerText = value;

        return btn;
    }

    /**
     *
     * @param {String} n - to validate if n is a number
     * @returns {boolean} - bool true if number false if string
     */
    isNumber(n) {
        let pattern = /^\d+$/;

        return pattern.test(n);
    }

}

export default NumericStepper;
